/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Components_Mediaslider_Thumbnail1Inputs */

const id_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

const ms_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

const da_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniature ${i?.index}`)
};

const de_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniaturansicht ${i?.index}`)
};

const en_us2_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

const es_es2_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatura ${i?.index}`)
};

const es_mx2_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatura ${i?.index}`)
};

const fil_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

const fr_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniature ${i?.index}`)
};

const it_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatura ${i?.index}`)
};

const hu_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatűr ${i?.index}`)
};

const nl_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatuur ${i?.index}`)
};

const no_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatyrbilde ${i?.index}`)
};

const pl_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatura ${i?.index}`)
};

const pt_br2_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

const pt_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatura ${i?.index}`)
};

const ro_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatură ${i?.index}`)
};

const fi_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pikkukuva ${i?.index}`)
};

const sv_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miniatyr ${i?.index}`)
};

const vi_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hình nhỏ ${i?.index}`)
};

const tr_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Küçük resim ${i?.index}`)
};

const cs_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Náhled ${i?.index}`)
};

const bg_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Миниатюра ${i?.index}`)
};

const ru_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Миниатюра ${i?.index}`)
};

const uk_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мініатюра ${i?.index}`)
};

const ar_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`صورة مصغرة ${i?.index}`)
};

const hi_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`थंबनेल ${i?.index}`)
};

const th_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รูปขนาดย่อ ${i?.index}`)
};

const ja_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サムネイル ${i?.index}`)
};

const zh_cn2_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

const zh_hant1_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

const ko_components_mediaslider_thumbnail1 = /** @type {(inputs: Components_Mediaslider_Thumbnail1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thumbnail ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Thumbnail {index}" |
*
* @param {Components_Mediaslider_Thumbnail1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mediaslider_thumbnail1 = /** @type {((inputs: Components_Mediaslider_Thumbnail1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mediaslider_Thumbnail1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mediaslider_thumbnail1(inputs)
	if (locale === "ms") return ms_components_mediaslider_thumbnail1(inputs)
	if (locale === "da") return da_components_mediaslider_thumbnail1(inputs)
	if (locale === "de") return de_components_mediaslider_thumbnail1(inputs)
	if (locale === "en-US") return en_us2_components_mediaslider_thumbnail1(inputs)
	if (locale === "es-ES") return es_es2_components_mediaslider_thumbnail1(inputs)
	if (locale === "es-MX") return es_mx2_components_mediaslider_thumbnail1(inputs)
	if (locale === "fil") return fil_components_mediaslider_thumbnail1(inputs)
	if (locale === "fr") return fr_components_mediaslider_thumbnail1(inputs)
	if (locale === "it") return it_components_mediaslider_thumbnail1(inputs)
	if (locale === "hu") return hu_components_mediaslider_thumbnail1(inputs)
	if (locale === "nl") return nl_components_mediaslider_thumbnail1(inputs)
	if (locale === "no") return no_components_mediaslider_thumbnail1(inputs)
	if (locale === "pl") return pl_components_mediaslider_thumbnail1(inputs)
	if (locale === "pt-BR") return pt_br2_components_mediaslider_thumbnail1(inputs)
	if (locale === "pt") return pt_components_mediaslider_thumbnail1(inputs)
	if (locale === "ro") return ro_components_mediaslider_thumbnail1(inputs)
	if (locale === "fi") return fi_components_mediaslider_thumbnail1(inputs)
	if (locale === "sv") return sv_components_mediaslider_thumbnail1(inputs)
	if (locale === "vi") return vi_components_mediaslider_thumbnail1(inputs)
	if (locale === "tr") return tr_components_mediaslider_thumbnail1(inputs)
	if (locale === "cs") return cs_components_mediaslider_thumbnail1(inputs)
	if (locale === "bg") return bg_components_mediaslider_thumbnail1(inputs)
	if (locale === "ru") return ru_components_mediaslider_thumbnail1(inputs)
	if (locale === "uk") return uk_components_mediaslider_thumbnail1(inputs)
	if (locale === "ar") return ar_components_mediaslider_thumbnail1(inputs)
	if (locale === "hi") return hi_components_mediaslider_thumbnail1(inputs)
	if (locale === "th") return th_components_mediaslider_thumbnail1(inputs)
	if (locale === "ja") return ja_components_mediaslider_thumbnail1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mediaslider_thumbnail1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mediaslider_thumbnail1(inputs)
	return ko_components_mediaslider_thumbnail1(inputs)
});
export { components_mediaslider_thumbnail1 as "components.mediaSlider.thumbnail" }